@if (value$ | async) {
  <svg sh-icon name="check" size="small"></svg>
}
